import React, { useEffect, useState } from "react";
import "./campaign.css";
import NewCampaignCard from "./NewCampaignCard";
import { ChevronRight, EllipsisVertical, Users } from "lucide-react";
import apiServiceHandler from "../../service/apiService";
import DripCard from "./DripCard";
import { useDispatch, useSelector } from "react-redux";
import { updateRefreshDripCardsData } from "../../redux/dripData";

const Campaign = () => {
  const [dripCards, setDripCards] = useState();
  const refreshDripCardsData = useSelector(
    (state) => state.dripData.refreshDripCardsData
  );
  const dispatch = useDispatch();

  const fetchCards = async () => {
    try {
      const response = await apiServiceHandler("GET", "api/drip-compaign", {});
      setDripCards(response?.allCampaigns);
    } catch (error) {
      console.error("Error getting Drip Campagin Cards", error);
    }
  };

  useEffect(() => {
    fetchCards();
  }, []);

  useEffect(() => {
    if (refreshDripCardsData) {
      fetchCards();
    }

    dispatch(updateRefreshDripCardsData(false));
  }, [refreshDripCardsData]);

  return (
    <div className="">
      <div className="campaign-page__content">
        <div className="campaign-page-section">
          <div className="campaign-page-section-header">
            <div className="campaign-page-header">
              <div className="campaign-page-header__eyebrow">
                Automated Communication Flows
              </div>
              <div className="campaign-page-header__top">
                <div className="campaign-page-header__content">
                  <div className="campaign-page-header__heading">
                    <span className="jurni-font-roboto">Drip Campaigns</span>
                  </div>
                </div>
                <div className="campaign-page-header__action"></div>
              </div>
            </div>
          </div>

          {/* body */}
          <div className="campaign-page-section__body">
            <div className="card-grid-container">
              {dripCards?.length > 0 &&
                dripCards?.map((card) => <DripCard card={card} />)}
              <NewCampaignCard />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Campaign;
